<template>
    <div class="database-view" v-if="section" v-route-title="section.name + '信息列表'">
        <div class="yq-news-section-list-page-head">
            {{section.name}}
        </div>
        <div class="clear"></div>
        <div class="gengduo">
            <news-query v-if="currentDatasource" :datasource="currentDatasource" :time-field="currentTab.timeField"
                        :time-interval="$route.query.timeInterval" @search="search"></news-query>
            <div v-if="data">
                <news-list v-if="!currentViewStyle" :data="data.content" :datasource="currentDatasource" view-name="list"
                           @show-details="showDetails"></news-list>
                <component v-if="currentViewStyle" :is="currentViewStyle.template.component"  :data="data.content"
                           :config="currentViewStyle.config" @show-details="showDetails" :page-number="data.number+1"
                           :page-size="10" :datasource="currentDatasource"></component>
            </div>
            <div class="magin10"></div>
            <div class="foot" v-if="data">
                <el-pagination
                        layout="prev, pager, next" background
                        :total="data.totalElements" :current-page="data.number+1"
                        @current-change="fetchData($event)">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import sectionService from '../../service/section'
    import newsSectionService from '../../service/news-section'
    import datasourceConfigService from '../../service/datasource-config'
    import NewsList from '../../components/common/NewsList'
    import NewsQuery from '../../components/common/NewsQuery'
    import viewStyleService from '../../service/view-style'
    import templates from '../../components/templates'

    export default {
        name: "NewsSectionDataList",
        components: {NewsList, NewsQuery},
        data(){
            return {
                section: null,
                sectionConfig: null,
                currentTab: null,
                currentDatasource: null,
                currentViewStyle: null,
                data: null,
                query: null
            }
        },
        created() {
            this.init()
        },
        methods: {
            async init() {
                const response = await sectionService.getSection(this.$route.query.sectionId,
                    {templateId: this.$route.query.templateId})
                this.section = response.data
                if (this.section.config) {
                    this.sectionConfig = JSON.parse(this.section.config)
                    if (this.sectionConfig.tabs && this.sectionConfig.tabs.length > 0) {
                        this.currentTab = this.sectionConfig.tabs.find(item => item.name === this.$route.query.tabName)
                        if(this.currentTab){
                            const datasource = (await datasourceConfigService.getDatasourceConfig(this.currentTab.datasource.id)).data
                            datasource.fields = JSON.parse(datasource.fields)
                            this.currentDatasource = datasource
                            if(this.currentTab.listStyle){
                                const viewStyle = (await viewStyleService.getViewStyle(this.currentTab.listStyle.id)).data
                                viewStyle.template = templates.find(item=>item.id===viewStyle.componentId)
                                this.currentViewStyle = viewStyle
                            }else{
                                this.currentViewStyle = null
                            }
                            await this.fetchData(1)
                        }
                    }
                }
            },
            async fetchData(page) {
                const params = {
                    pageId: this.$route.query.pageId,
                    templateId: this.$route.query.templateId,
                    sectionId: this.$route.query.sectionId,
                    tabName: this.currentTab.name,
                    timeField: this.currentTab.timeField,
                    viewName: 'list',
                    fields: this.currentViewStyle ? this.currentViewStyle.template.getFields(this.currentViewStyle.config):null,
                    page: page - 1, size: 10,
                    sort: newsSectionService.parseSortExpr(this.currentTab.sort)
                }
                if(this.query){
                    params.query = this.query
                }else{
                    params.timeField = this.currentTab.timeField
                    params.timeInterval = this.$route.query.timeInterval
                }
                const response = await newsSectionService.search(params)
                this.data = response.data
            },
            search(query){
                this.query = query
                this.fetchData(1)
            },
            showDetails(id){
                const url = [document.location.origin, document.location.pathname,
                    '#/main/news-section/details?sectionId=', this.$route.query.sectionId, '&pageId=', this.$route.query.pageId || '',
                    '&templateId=', this.$route.query.templateId || '', '&tabName=', encodeURIComponent(this.currentTab.name),
                    "&id=", encodeURIComponent(id)
                ]
                window.open(url.join(''), '_blank')
            }
        }
    }
</script>

<style scoped>

</style>
